import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`As Syria entered its 9th year of conflict, which forced more than 5.6 million people to flee their homes, the EU-funded cash assistance scheme in Turkey helped prevent 1.7 million vulnerable refugees – mostly Syrians – from falling deeper into poverty.`}</strong></p>
    <p>{`Turkey has taken more Syrian refugees than any other country. Of the approximately 4 million refugees in Turkey, some 3.6 million are from Syria. With work opportunities being scarce, many families have struggled to make ends meet.`}</p>
    <p>{`The Emergency Social Safety Net (ESSN) programme, which was implemented by WFP and entirely funded by the EU, provided monthly cash allowances to the most vulnerable refugees living in Turkey. Each member of an eligible family received the equivalent of around €19 (120 Turkish liras) per month via a special debit card – plus quarterly top-ups according to family size – to help them cover essential needs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      